export default __webpack_public_path__ + "static/media/3.4f980f5a.jpg";